export const i18nConfig = {
  'zh-CN': {
    // 通用
    common: {
      confirm: '确认',
      cancel: '取消',
      save: '保存',
      delete: '删除',
      edit: '编辑',
      add: '添加',
      search: '搜索',
      reset: '重置',
      submit: '提交',
      back: '返回',
      next: '下一步',
      previous: '上一步',
      loading: '加载中...',
      noData: '暂无数据',
      success: '操作成功',
      error: '操作失败',
      warning: '警告',
      info: '提示',
      rememberAccount: '记住账号',
      selectLanguage: '选择语言',
      yes: '是',
      no: '否',
      tip: '提示'
    },
    // 导航菜单
    menu: {
      home: '首页',
      dashboard: '仪表盘',
      workbench: '工作台',
      userManage: '用户管理',
      systemSettings: '系统设置',
      companyManage: '企业管理',
      cardManage: '卡片管理',
      activityManage: '活动管理',
      orderManage: '订单管理',
      dataAnalysis: '数据分析',
      enterpriseService: '企业服务',
      companyManageList: '企业管理列表',
      oemManage: 'OEM管理',
      companyDetail: '企业详情',
      videoManage: '短视频管理',
      moduleManage: '模块管理',
      permissionsManage: '权限管理',
      operationRecords: '操作记录',
      serviceOrder: '服务订单',
      visitorData: '访客数据',
      cardDetail: '名片详情',
      companyCard: '企业卡片',
      companyNotice: '企业通知',
      yimaiSmartCard: '睿哲智能名片',
      yimaiCrmCard: '睿哲智能CRM',
      wxappletManage: '小程序管理',
      codeManage: '代码管理',
      dataCenter: '数据中心',
      updateAnnouncement: '更新公告',
      publishActivity: '发布活动',
      editActivity: '编辑活动',
      buyActivity: '购买详情',
      orderDetail: '订单详情',
      versionManage: '小程序版本管理'
    },
    // 页面标题
    pageTitle: {
      home: '首页',
      login: '登录',
      dashboard: '仪表盘',
      userList: '用户列表',
      userDetail: '用户详情',
      companyList: '企业列表',
      cardList: '卡片列表',
      activityList: '活动列表',
      orderList: '订单列表',
      companyManage: '企业管理',
      customerManage: '客户管理',
      activityManage: '活动管理',
      serviceOrder: '服务订单',
      permissionsManage: '权限管理',
      cardPage: '卡片详情',
      companyCardPage: '企业卡片',
      versionManage: '版本管理',
      operationRecords: '操作记录',
      modelSwitch: '模式开关',
      visitorData: '访客数据',
      companyVideo: '企业视频',
      companyOemManage: '企业OEM管理',
      companyNotice: '企业通知',
      yimaiSmartCard: '易脉智能卡片',
      wxappletManage: '小程序管理',
      yimaiCrmCard: '易脉CRM卡片',
      codeManage: '代码管理',
      index: '首页'
    },
    // 表单标签
    form: {
      username: '用户名',
      password: '密码',
      email: '邮箱',
      phone: '手机号',
      name: '姓名',
      company: '公司',
      role: '角色',
      status: '状态',
      createTime: '创建时间',
      updateTime: '更新时间',
      description: '描述',
      remark: '备注',
      companyName: '企业名称',
      administrator: '管理员',
      administratorPhone: '管理员电话',
      employeeCount: '企业员工',
      cardCount: '总名片数',
      unusedCardCount: '未用名片数',
      customerCount: '客户人数',
      wechatNumber: '微信号码',
      expiryTime: '到期时间',
      purchaseVersion: '购买版本',
      companyType: '企业类型',
      affiliatedCompany: '所属企业',
      certificationStatus: '企业认证状态',
      certificationTime: '认证时间',
      operation: '操作',
      detail: '详情',
      setting: '设置',
      cardId: '编号',
      name: '姓名',
      phone: '手机号码',
      position: '职位',

      createTime: '创建时间',
      currentCompany: '当前企业',
      totalPurchase: '总购买数',
      paymentAmount: '支付金额',
      deadline: '截止日期',
      selectDate: '选择日期',
      agentPrice: '代理价格',
      agentId: '代理ID',
      activityStatus: '活动状态',
      activityName: '活动名称',
      publishTime: '发布时间（首次）',
      activityTime: '活动时间',
      activityId: '活动编号',
      useDuration: '使用时长',
      useCount: '使用人数',
      shortVideo: '短视频',
      pleaseSelect: '请选择',
      newPublish: '新增发布',
      ended: '已结束',
      inProgress: '进行中',
      pending: '待上线',
      unknown: '未知',
      offline: '下架',
      serialNumber: '序号',
      durationPurchase: '使用时长购买数/年',
      countPurchase: '使用人数购买数/位',
      videoPurchase: '短视频购买数/次',
      adminName: '管理员名称',
      contactPhone: '联系电话',
      companyNamePlaceholder: '企业名称',
      adminNamePlaceholder: '管理员名称',
      adminPhonePlaceholder: '管理员电话',
      searchKeyword: '搜索关键字',
      create: '新建',
      employeeName: '员工姓名',
      gender: '性别',
      job: '职务',
      loginAccount: '登录账号',
      enabled: '启用',
      disabled: '禁用',
      male: '男',
      female: '女',
      enabledStatus: '已启用',
      disabledStatus: '已禁用',
      enable: '启用',
      disable: '禁用',
      back: '返回',
      openWechatScan: '打开微信扫一扫',
      previewCardInfo: '立即预览用户名片信息',
      delete: '删除',
      companyDetail: '企业详情',
      agentCompanyList: '代理企业列表',
      setAgentPrice: '设置代理价格',
      setAsAgent: '设置成为代理商',
      yuanPerCard: '港元/张',
      inputAgentPrice: '输入代理价',
      cancelAgentQualification: '是否取消代理商资格?',
      versionName: '版本名称',
      versionDescription: '版本描述',
      versionPrice: '版本价格',
      versionFeatures: '版本功能',
      versionStatus: '版本状态',
      versionType: '版本类型',
      versionCode: '版本代码',
      jumpType: '跳轉類型',
      absolutePath: '絕對路徑',
      appletPath: '小程序路徑',
      jumpPath: '跳轉路徑',
      versionNumber: '版本号',
      releaseDate: '发布日期',
      updateDate: '更新日期',
      versionNotes: '版本说明',
      versionHistory: '版本历史',
      versionComparison: '版本对比',
      upgradeVersion: '升级版本',
      downgradeVersion: '降级版本',
      versionManagement: '版本管理',
      versionControl: '版本控制',
      versionBackup: '版本备份',
      versionRestore: '版本恢复',
      userEnd: '用户端',
      crmEnd: 'crm端',
      templateId: '模板ID',
      description: '描述',
      createTime: '创建时间',
      operation: '操作',
      codeCommit: '代码提交',
      submitSuccess: '提交成功',
      usernameOrCompanyName: '用户名/企业名称',
      loginUsername: '登录用户名',
      companyName: '企业名称',
      operationName: '操作名称',
      operationContent: '操作内容',
      operationTime: '操作时间',
      purchaseService: '购买服务',
      setAgent: '设置代理商',
      serialNumber: '编号',
      appName: '小程序名称',
      crmEnterpriseServiceSwitch: 'CRM企业服务开关',
      valueAddedServiceSwitch: '增值服务开关',
      userAuthorizationSwitch: '用户授权开关',
      phoneAuthorizationSwitch: '手机授权开关',
      open: '打开',
      close: '关闭',
      pleaseEnterVideoLimit: '请输入视频限制数量',
      lengthLimit: '长度在 1 到 8 个字符',
      selectTime: '选择时间',
      startDate: '开始日期',
      endDate: '结束日期',
      phoneNumber: '电话号码',
      pleaseEnterPhoneNumber: '请输入电话号码',
      pleaseSelect: '请选择',
      submitTime: '提交时间',
      notContacted: '未联系',
      contacted: '已经联系',
      confirmContact: '确认联系',
      contactedStatus: '已联系',
      operator: '操作人',
      lastWeek: '最近一周',
      lastMonth: '最近一个月',
      lastThreeMonths: '最近三个月',
      shortVideoSwitch: '短视频开关',
      uploadableVideoCount: '可上传视频数量',
      contactPhone: '联系电话',
      edit: '编辑',
      videoLimitCount: '视频限制数量',
      cancel: '取消',
      companyId: '公司ID',
      configId: '配置ID',
      bossUserId: 'BOSS用户ID',
      bossCardId: 'BOSS名片ID',
      companyPassword: '公司口令',
      configEnd: '配置端',
      cardEnd: '名片端',
      crmPcWebsiteApp: 'CRM-PC网站应用',
      cardPayment: '名片支付',
      wechatOfficialAccount: '微信公众号',
      crmPayment: 'CRM支付',
      appId: 'AppID',
      appSecret: 'AppSecret',
      companyKey: 'companyKey',
      merchantNumber: '商户号',
      auditStatus: '审核状态',
      submitFailed: '提交失败',
      submitSuccess: '提交成功',
      auditInProgress: '审核中',
      auditSubmitFailed: '审核提交失败',
      auditFailed: '审核失败',
      auditPassed: '审核通过',
      releaseSuccess: '发布成功',
      releaseFailed: '发布失败',
      pendingReview: '待审核',
      rejected: '拒绝',
      authorizationStatus: '授权状态',
      success: '成功',
      failed: '失败',
      enterpriseType: '企业类型',
      singleEnterprise: '单企业',
      modify: '修改',
      view: '查看',
      oemConfig: 'OEM配置',
      currentEnterprise: '当前企业',
      boosUserId: 'BOOS用户ID',
      boosCardId: 'BOOS名片ID',
      administratorPhone: '管理员电话',
      companyPasswordLabel: '公司口令',
      configEndLabel: '配置端',
      appNameLabel: '小程序名称',
      appIdLabel: 'AppID',
      appSecretLabel: 'AppSecret',
      companyKeyLabel: 'companyKey',
      merchantNumberLabel: '商户号',
      auditStatusLabel: '审核状态',
      authorizationStatusLabel: '授权状态',
      enterpriseTypeLabel: '企业类型',
      createTimeLabel: '创建时间',
      operationLabel: '操作',
      modifyOemCompanyInfo: '修改OEM公司信息',
      selectDateRange: '选择日期范围',
      dataOverview: '数据概况',
      userPortrait: '用户画像',
      newUserCount: '新增使用人数',
      userCount: '使用人数',
      totalUserCount: '总用户数',
      userGrowth: '用户增长情况',
      userCountGrowth: '用户人数增长情况',
      genderAgeDistribution: '性别及年龄分布',
      last7Days: '近7天',
      last15Days: '近15天',
      last30Days: '近30天',
      today: '今天',
      yesterday: '昨天',
      last7DaysRange: '最近七天',
      companyName: '公司名称',
      query: '查询',
      manager: '管理人',
      contactInfo: '联系方式',
      appName: '小程序名称',
      appletCategory: '小程序类别',
      userEnd: '用户端',
      crmEnd: 'crm端',
      latestStatus: '最新状态',
      currentVersion: '当前版本',
      selectVersion: '选择版本',
      getVersion: '获取版本',
      operation: '操作',
      getExperienceCode: '获取体验码',
      getAuditResult: '获取审核结果',
      submitAudit: '提交审核',
      release: '发布',
      versionSelection: '版本选择',
      version: '版本',
      description: '描述',
      versionUpdate: '版本更新',
      cancel: '取消',
      confirm: '确定',
      scanCodeExperience: '扫码体验',
      failureReason: '失败原因',
      none: '暂无',
      draftBox: '草稿箱',
      versionNumber: '版本号',
      description: '描述',
      sourceApplet: '来源小程序',
      sourceAppletId: '来源小程序ID',
      uploadDeveloper: '上传开发者',
      submitTime: '提交时间',
      addToTemplateLibrary: '添加到模板库',
      appletTemplateLibrary: '小程序模板库',
      templateId: '模板ID',
      addToTemplateLibraryTime: '添加到模板库时间',
      addVersion: '添加版本',
      addAppletVersionInfo: '添加小程序版本信息',
      appletId: '小程序ID',
      versionNum: '版本号',
      desc: '描述',
      refresh: '刷新',
      export: '导出',
      newSituation: '新增情况',
      todayNewUsers: '今日新增用户',
      todayNewCompany: '今日新增企业',
      totalCompanyCount: '总企业数',
      pageNotFound: '404 页面未找到',
      serialNumber: '序号',
      noticeTitle: '公告标题',
      noticeContent: '公告内容',
      publishTerminal: '发布终端',
      appletEnd: '小程序端',
      all: '全部',
      startTime: '开始时间',
      endTime: '截止时间',
      // 组件相关文本
      userInfo: '用户信息',
      companyInfo: '企业信息',
      administratorInfo: '管理员信息',
      orderDetail: '订单详情',
      orderList: '订单列表',
      userAvatar: '用户头像',
      name: '姓名',
      phoneNumber: '手机号',
      wechatNumber: '微信号码',
      email: '邮箱',
      company: '所属企业',
      position: '职位',
      cardVisits: '名片访问量',
      createTime: '创建时间',
      personalIntro: '个人简介',
      imageDisplay: '图片展示',
      companyLogo: '企业LOGO',
      companyName: '企业名称',
      industry: '所属行业',
      companyNotice: '企业公告',
      companyEmployees: '企业员工',
      customerCount: '客户人数',
      notAuthorized: '未授权',
      people: '人',
      shortVideoTotalCount: '短视频总次数',
      cardExpiryTime: '名片到期时间',
      productType: '商品类型',
      orderNumber: '订单编号',
      orderTime: '下单时间',
      paymentMethod: '支付方式',
      addNotice: '新增公告',
      editNotice: '编辑公告',
      noticeTitle: '公告标题',
      noticeContent: '公告内容',
      publishTerminal: '发布终端',
      all: '全部',
      addEmployee: '新增员工',
      editEmployeeInfo: '编辑员工信息',
      back: '返回',
      basicInfo: '基础信息',
      requiredFields: '都为必填项',
      loginAccount: '登录账号',
      loginPassword: '登录密码',
      passwordNotModified: '密码不作修改则不填',
      employeeName: '员工姓名',
      employeeGender: '员工性别',
      male: '男',
      female: '女',
      employeePosition: '员工职务',
      pleaseSelect: '请选择',
      permissionSetting: '权限设置',
      selectAll: '全选',
      permissionType: '权限类型',
      permissionName: '权限名称',
      permissionDescription: '权限描述',
      clear: '清空',
      submit: '提交',
      activityContent: '活动内容',
      activityName: '活动名称',
      price: '价格',
      operation: '操作',
      pleaseEnterActivityName: '请输入活动名称',
      pleaseEnterPrice: '请输入价格',
      pleaseEnterDuration: '请输入时长',
      year: '年',
      yuan: '港元',
      activityDate: '活动日期',
      phoneEdit: '电话编辑',
      consultationPhone: '咨询电话',
      pleaseEnterConsultationPhone: '请输入咨询电话',
      save: '保存',
      publish: '发布',
      pleaseEnterUseTotalCount: '请输入使用总人数',
      companyUseTotalCount: '企业使用总人数',
      person: '位',
      pleaseEnterCardDuration: '请输入名片时长',
      companyUseCardDuration: '企业使用名片时长',
      pleaseEnterShortVideoCount: '请输入短视频数量',
      companyUseShortVideoCount: '企业使用短视频数量',
      piece: '个',
      pleaseSelectDate: '请选择日期',
      demoEnvironmentCannotSave: '演示环境不能保存,请谅解',
      durationRequired: '时长必填',
      priceRequired: '价格必填',
      maxAdd6Activities: '最多一次添加6个活动',
      operationSuccess: '操作成功',
      pleaseRelogin: '请重新登录',
      activityTime: '活动时间',
      activityStatus: '活动状态',
      publishTime: '发布时间',
      orderCount: '订单数量',
      orderAmount: '订单金额',
      today: '今天',
      last7Days: '近7天',
      last15Days: '近15天',
      last30Days: '近30天',
      companyNameOrAdminPhone: '企业名称/管理员电话',
      query: '查询',
      export: '导出',
      serialNumber: '序号',
      adminName: '管理员名称',
      contactPhone: '联系电话',
      detail: '详情',
      activityOrder: '活动订单',
      cardDuration: '名片时长',
      cardUseCount: '名片使用人数',
      shortVideoCount: '短视频数量',
      pendingOnline: '待上线',
      inProgress: '进行中',
      ended: '已结束',
      enterpriseDetail: '企业详情',
      generalManager: '总经理',
      deputyGeneralManager: '副总经理',
      finance: '财务',
      operations: '运营',
      technicalDirector: '技术总监',
      hrSpecialist: '人事专员',
      // 新增的OEM管理相关文本
      cardEnd: '名片端',
      crm: 'crm',
      crmPcWebsiteApp: 'CRM-PC网站应用',
      cardPayment: '名片支付',
      wechatOfficialAccount: '微信公众号',
      crmPayment: 'CRM支付',
      auditPassed: '审核通过',
      pendingReview: '待审核',
      rejected: '拒绝',
      success: '成功',
      failed: '失败',
      singleEnterprise: '单企业',
      administratorPhone: '管理员手机号',
      companyPassword: '公司口令',
      appName: '小程序名称',
      merchantId: '商户ID',
      merchantKey: '商户秘钥',
      paymentP12Certificate: '支付p12证书',
      upload: '上传',
      viewCardIdByPhone: '查看手机号对应的名片ID',
      phoneNumber: '手机号',
      cardId: '名片Id',
      userId: '用户Id',
      companyId: '公司Id',
      close: '关闭',
      oemConfig: 'oem配置',
      systemName: '系统名称',
      oemDomain: 'oem域名',
      companyLogo: '公司logo',
      websiteIcon: '网站icon',
      modifySuccess: '修改成功',
      saveSuccess: '保存成功',
      // 分页组件文本
      total: '共 {total} 条',
      sizes: '条/页',
      prev: '上一页',
      next: '下一页',
      jumper: '前往',
      page: '页',
      advancedVersion: '高级版',
      normalVersion: '普通版',
      agent: '代理商',
      singleCompany: '单企业',
      notCertified: '未认证',
      certified: '已认证',
      certifying: '认证中',
      certificationFailed: '认证失败',
      unknown: '未知',
      auditCertification: '认证审核',
      approve: '批准',
      reject: '拒绝',
      certificationRemark: '审核备注',
      pleaseEnterRemark: '请输入审核备注',
      auditSuccess: '审核成功',
      auditFailed: '审核失败',
      certificationApplyCompanyName: '申请认证企业名称',
      certificationPhone: '申请人联系电话',
      certificationImages: '认证图片',
     },
     // 按钮文本
    button: {
      login: '登录',
      logout: '退出登录',
      register: '注册',
      forgotPassword: '忘记密码',
      changePassword: '修改密码',
      viewDetail: '查看详情',
      download: '下载',
      upload: '上传',
      export: '导出',
      import: '导入',
      refresh: '刷新',
      filter: '筛选',
      sort: '排序',
      exportAll: '全部导出',
      search: '查询',
      confirm: '确定',
      cancel: '取消',
      add: '去补充',
      edit: '编辑',
      delete: '删除'
    },
    // 状态文本
    status: {
      active: '启用',
      inactive: '禁用',
      pending: '待处理',
      processing: '处理中',
      completed: '已完成',
      failed: '失败',
      online: '在线',
      offline: '离线',
      all: '全部',
      normalCompany: '普通企业',
      authorizedCompany: '授权企业',
      expiredCompany: '授权已到期企业',
      applyingCompany: '申请认证企业',
      agent: '代理商',
      singleCompany: '单企业',
      normalUser: '普通用户',
      companyAdmin: '企业管理员'
    },
    // 消息提示
    message: {
      loginSuccess: '登录成功',
      confirmDeleteNotice: '確認刪除公告?',
      loginFailed: '登录失败',
      logoutSuccess: '退出成功',
      saveSuccess: '保存成功',
      deleteSuccess: '删除成功',
      operationSuccess: '操作成功',
      operationFailed: '操作失败',
      confirmDelete: '确认删除吗？',
      confirmLogout: '确认退出吗？',
      confirmRelease: '审核通过立即发布?',
      confirmUpdateVersion: '是否立即更新版本?',
      noPermission: '没有权限',
      networkError: '网络错误',
      serverError: '服务器错误',
      pleaseEnterUsername: '请输入账号',
      pleaseEnterPassword: '请输入密码',
      pleaseEnterAgentId: '请输入代理商ID',
      submitSuccess: '提交成功，即将刷新页面',
      permissionManagement: '权限管理',
      startDate: '开始日期',
      endDate: '结束日期',
      companyNameOrPhone: '企业名称/管理员电话',
      notSetAgentId: '还没有设置代理商ID',
      enterNameOrPhone: '请输入姓名或电话用户',
      editNoticeSuccess: '编辑公告成功，刷新页面',
      addNoticeSuccess: '新增公告成功，刷新页面',
      editEmployeeSuccess: '编辑员工成功，刷新页面',
      addEmployeeSuccess: '新增员工成功，刷新页面',
      editEmployeeFailed: '编辑员工失败',
      addEmployeeFailed: '新增员工失败',
      systemNamePlaceholder: '如：睿哲智能CRM',
      oemDomainPlaceholder: '如：crm.yourdomain.com',
      logoSizePlaceholder: '尺寸：30*30',
      iconSizePlaceholder: '尺寸：128*128',
      pleaseEnterNoticeTitle: '请输入公告标题',
      pleaseEnterNoticeContent: '请输入公告内容',
      pleaseEnterJumpPath: '请输入跳转路径',
      pleaseEnterLoginAccount: '请输入登录账号',
      pleaseEnterEmployeeName: '请输入员工姓名',
      uploadImageSizeLimit: '上传头像图片大小不能超过 2MB!',
      uploadImageFormatError: '上传头像图片只能是 JPG 格式!',
      viewCardIdByPhone: '查看手机号对应的名片ID',
      systemName: '系统名称',
      oemDomain: 'oem域名',
      websiteIcon: '网站icon',
      merchantKey: '商户秘钥',
      paymentP12Certificate: '支付p12证书',
      languageSwitchedToChinese: '已切换到简体中文',
      languageSwitchedToTraditional: '已切換到繁體中文',
      languageSwitchedToEnglish: 'Switched to English'
    }
  },
  'zh-TW': {
    // 通用
    common: {
      confirm: '確認',
      cancel: '取消',
      save: '保存',
      delete: '刪除',
      edit: '編輯',
      add: '添加',
      search: '搜索',
      reset: '重置',
      submit: '提交',
      back: '返回',
      next: '下一步',
      previous: '上一步',
      loading: '加載中...',
      noData: '暫無數據',
      success: '操作成功',
      error: '操作失敗',
      warning: '警告',
      info: '提示',
      rememberAccount: '記住賬號',
      selectLanguage: '選擇語言',
      yes: '是',
      no: '否',
      tip: '提示'
    },
    // 导航菜单
    menu: {
      home: '首頁',
      dashboard: '儀表盤',
      workbench: '工作台',
      userManage: '用戶管理',
      systemSettings: '系統設置',
      companyManage: '企業管理',
      cardManage: '卡片管理',
      activityManage: '活動管理',
      orderManage: '訂單管理',
      dataAnalysis: '數據分析',
      enterpriseService: '企業服務',
      companyManageList: '企業管理列表',
      oemManage: 'OEM管理',
      companyDetail: '企業詳情',
      videoManage: '短視頻管理',
      moduleManage: '模塊管理',
      permissionsManage: '權限管理',
      operationRecords: '操作記錄',
      serviceOrder: '服務訂單',
      visitorData: '訪客數據',
      cardDetail: '名片詳情',
      companyCard: '企業卡片',
      companyNotice: '企業通知',
      yimaiSmartCard: '睿哲智能名片',
      yimaiCrmCard: '睿哲智能CRM',
      wxappletManage: '小程序管理',
      codeManage: '代碼管理',
      dataCenter: '數據中心',
      updateAnnouncement: '更新公告',
      publishActivity: '發布活動',
      editActivity: '編輯活動',
      buyActivity: '購買詳情',
      orderDetail: '訂單詳情',
      versionManage: '小程序版本管理'
    },
    // 页面标题
    pageTitle: {
      home: '首頁',
      login: '登錄',
      dashboard: '儀表盤',
      userList: '用戶列表',
      userDetail: '用戶詳情',
      companyList: '企業列表',
      cardList: '卡片列表',
      activityList: '活動列表',
      orderList: '訂單列表',
      companyManage: '企業管理',
      customerManage: '客戶管理',
      activityManage: '活動管理',
      serviceOrder: '服務訂單',
      permissionsManage: '權限管理',
      cardPage: '卡片詳情',
      companyCardPage: '企業卡片',
      versionManage: '版本管理',
      operationRecords: '操作記錄',
      modelSwitch: '模式開關',
      visitorData: '訪客數據',
      companyVideo: '企業視頻',
      companyOemManage: '企業OEM管理',
      companyNotice: '企業通知',
      yimaiSmartCard: '易脈智能卡片',
      wxappletManage: '小程序管理',
      yimaiCrmCard: '易脈CRM卡片',
      codeManage: '代碼管理',
      index: '首頁'
    },
    // 表单标签
    form: {
      username: '用戶名',
      password: '密碼',
      email: '郵箱',
      phone: '手機號',
      name: '姓名',
      company: '公司',
      role: '角色',
      status: '狀態',
      createTime: '創建時間',
      updateTime: '更新時間',
      description: '描述',
      remark: '備註',
      companyName: '企業名稱',
      administrator: '管理員',
      administratorPhone: '管理員電話',
      employeeCount: '企業員工',
      cardCount: '總名片數',
      unusedCardCount: '未用名片數',
      customerCount: '客戶人數',
      wechatNumber: '微信號碼',
      expiryTime: '到期時間',
      purchaseVersion: '購買版本',
      companyType: '企業類型',
      affiliatedCompany: '所屬企業',
      certificationStatus: '企業認證狀態',
      certificationTime: '認證時間',
      operation: '操作',
      detail: '詳情',
      setting: '設置',
      cardId: '編號',
      name: '姓名',
      phone: '手機號碼',
      position: '職位',
      createTime: '創建時間',
      currentCompany: '當前企業',
      totalPurchase: '總購買數',
      paymentAmount: '支付金額',
      deadline: '截止日期',
      selectDate: '選擇日期',
      agentPrice: '代理價格',
      agentId: '代理ID',
      activityStatus: '活動狀態',
      activityName: '活動名稱',
      publishTime: '發布時間（首次）',
      activityTime: '活動時間',
      activityId: '活動編號',
      useDuration: '使用時長',
      useCount: '使用人數',
      shortVideo: '短視頻',
      pleaseSelect: '請選擇',
      newPublish: '新增發布',
      ended: '已結束',
      inProgress: '進行中',
      pending: '待上線',
      unknown: '未知',
      offline: '下架',
      serialNumber: '序號',
      durationPurchase: '使用時長購買數/年',
      countPurchase: '使用人數購買數/位',
      videoPurchase: '短視頻購買數/次',
      adminName: '管理員名稱',
      contactPhone: '聯繫電話',
      companyNamePlaceholder: '企業名稱',
      adminNamePlaceholder: '管理員名稱',
      adminPhonePlaceholder: '管理員電話',
      searchKeyword: '搜索關鍵字',
      create: '新建',
      employeeName: '員工姓名',
      gender: '性別',
      job: '職務',
      loginAccount: '登錄賬號',
      enabled: '啟用',
      disabled: '禁用',
      male: '男',
      female: '女',
      enabledStatus: '已啟用',
      disabledStatus: '已禁用',
      enable: '啟用',
      disable: '禁用',
      back: '返回',
      openWechatScan: '打開微信掃一掃',
      previewCardInfo: '立即預覽用戶名片信息',
      delete: '刪除',
      companyDetail: '企業詳情',
      agentCompanyList: '代理企業列表',
      agent: '代理商',
      setAgentPrice: '設置代理價格',
      setAsAgent: '設置成為代理商',
      yuanPerCard: '港元/張',
      inputAgentPrice: '輸入代理價',
      cancelAgentQualification: '是否取消代理商資格?',
      versionName: '版本名稱',
      versionDescription: '版本描述',
      versionPrice: '版本價格',
      versionFeatures: '版本功能',
      versionStatus: '版本狀態',
      versionType: '版本類型',
      versionCode: '版本代碼',
      versionNumber: '版本號',
      releaseDate: '發布日期',
      updateDate: '更新日期',
      versionNotes: '版本說明',
      versionHistory: '版本歷史',
      versionComparison: '版本對比',
      upgradeVersion: '升級版本',
      downgradeVersion: '降級版本',
      versionManagement: '版本管理',
      versionControl: '版本控制',
      versionBackup: '版本備份',
      versionRestore: '版本恢復',
      userEnd: '用戶端',
      crmEnd: 'crm端',
      templateId: '模板ID',
      description: '描述',
      createTime: '創建時間',
      operation: '操作',
      codeCommit: '代碼提交',
      submitSuccess: '提交成功',
      usernameOrCompanyName: '用戶名/企業名稱',
      loginUsername: '登錄用戶名',
      companyName: '企業名稱',
      operationName: '操作名稱',
      operationContent: '操作內容',
      operationTime: '操作時間',
      purchaseService: '購買服務',
      setAgent: '設置代理商',
      serialNumber: '編號',
      appName: '小程序名稱',
      crmEnterpriseServiceSwitch: 'CRM企業服務開關',
      valueAddedServiceSwitch: '增值服務開關',
      userAuthorizationSwitch: '用戶授權開關',
      phoneAuthorizationSwitch: '手機授權開關',
      open: '打開',
      close: '關閉',
      pleaseEnterVideoLimit: '請輸入視頻限制數量',
      lengthLimit: '長度在 1 到 8 個字符',
      selectTime: '選擇時間',
      startDate: '開始日期',
      endDate: '結束日期',
      phoneNumber: '電話號碼',
      pleaseEnterPhoneNumber: '請輸入電話號碼',
      pleaseSelect: '請選擇',
      submitTime: '提交時間',
      notContacted: '未聯繫',
      contacted: '已經聯繫',
      confirmContact: '確認聯繫',
      contactedStatus: '已聯繫',
      operator: '操作人',
      lastWeek: '最近一週',
      lastMonth: '最近一個月',
      lastThreeMonths: '最近三個月',
      shortVideoSwitch: '短視頻開關',
      uploadableVideoCount: '可上傳視頻數量',
      contactPhone: '聯繫電話',
      edit: '編輯',
      videoLimitCount: '視頻限制數量',
      cancel: '取消',
      companyId: '公司ID',
      configId: '配置ID',
      bossUserId: 'BOSS用戶ID',
      bossCardId: 'BOSS名片ID',
      companyPassword: '公司口令',
      configEnd: '配置端',
      cardEnd: '名片端',
      crmPcWebsiteApp: 'CRM-PC網站應用',
      cardPayment: '名片支付',
      wechatOfficialAccount: '微信公眾號',
      crmPayment: 'CRM支付',
      appId: 'AppID',
      appSecret: 'AppSecret',
      companyKey: 'companyKey',
      merchantNumber: '商戶號',
      auditStatus: '審核狀態',
      submitFailed: '提交失敗',
      submitSuccess: '提交成功',
      auditInProgress: '審核中',
      auditSubmitFailed: '審核提交失敗',
      auditFailed: '審核失敗',
      auditPassed: '審核通過',
      releaseSuccess: '發布成功',
      releaseFailed: '發布失敗',
      pendingReview: '待審核',
      rejected: '拒絕',
      authorizationStatus: '授權狀態',
      success: '成功',
      failed: '失敗',
      enterpriseType: '企業類型',
      agent: '代理商',
      singleEnterprise: '單企業',
      modify: '修改',
      view: '查看',
      oemConfig: 'OEM配置',
      currentEnterprise: '當前企業',
      boosUserId: 'BOOS用戶ID',
      boosCardId: 'BOOS名片ID',
      administratorPhone: '管理員電話',
      companyPasswordLabel: '公司口令',
      configEndLabel: '配置端',
      appNameLabel: '小程序名稱',
      appIdLabel: 'AppID',
      appSecretLabel: 'AppSecret',
      companyKeyLabel: 'companyKey',
      merchantNumberLabel: '商戶號',
      auditStatusLabel: '審核狀態',
      authorizationStatusLabel: '授權狀態',
      enterpriseTypeLabel: '企業類型',
      createTimeLabel: '創建時間',
      operationLabel: '操作',
      modifyOemCompanyInfo: '修改OEM公司信息',
      selectDateRange: '選擇日期範圍',
      dataOverview: '數據概況',
      userPortrait: '用戶畫像',
      newUserCount: '新增使用人數',
      userCount: '使用人數',
      totalUserCount: '總用戶數',
      userGrowth: '用戶增長情況',
      userCountGrowth: '用戶人數增長情況',
      genderAgeDistribution: '性別及年齡分佈',
      last7Days: '近7天',
      last15Days: '近15天',
      last30Days: '近30天',
      today: '今天',
      yesterday: '昨天',
      last7DaysRange: '最近七天',
      companyName: '公司名稱',
      query: '查詢',
      manager: '管理人',
      contactInfo: '聯繫方式',
      appName: '小程序名稱',
      appletCategory: '小程序類別',
      userEnd: '用戶端',
      crmEnd: 'crm端',
      latestStatus: '最新狀態',
      currentVersion: '當前版本',
      selectVersion: '選擇版本',
      getVersion: '獲取版本',
      operation: '操作',
      getExperienceCode: '獲取體驗碼',
      getAuditResult: '獲取審核結果',
      submitAudit: '提交審核',
      release: '發布',
      versionSelection: '版本選擇',
      version: '版本',
      description: '描述',
      versionUpdate: '版本更新',
      cancel: '取消',
      confirm: '確定',
      scanCodeExperience: '掃碼體驗',
      failureReason: '失敗原因',
      none: '暫無',
      draftBox: '草稿箱',
      versionNumber: '版本號',
      description: '描述',
      sourceApplet: '來源小程序',
      sourceAppletId: '來源小程序ID',
      uploadDeveloper: '上傳開發者',
      submitTime: '提交時間',
      addToTemplateLibrary: '添加到模板庫',
      appletTemplateLibrary: '小程序模板庫',
      templateId: '模板ID',
      addToTemplateLibraryTime: '添加到模板庫時間',
      addVersion: '添加版本',
      addAppletVersionInfo: '添加小程序版本信息',
      appletId: '小程序ID',
      versionNum: '版本號',
      desc: '描述',
      refresh: '刷新',
      export: '導出',
      newSituation: '新增情況',
      todayNewUsers: '今日新增用戶',
      todayNewCompany: '今日新增企業',
      totalCompanyCount: '總企業數',
      pageNotFound: '404 頁面未找到',
      serialNumber: '序號',
      noticeTitle: '公告標題',
      noticeContent: '公告內容',
      publishTerminal: '發布終端',
      appletEnd: '小程序端',
      all: '全部',
      startTime: '開始時間',
      endTime: '截止時間',
      // 組件相關文本
      userInfo: '用戶信息',
      companyInfo: '企業信息',
      administratorInfo: '管理員信息',
      orderDetail: '訂單詳情',
      orderList: '訂單列表',
      userAvatar: '用戶頭像',
      name: '姓名',
      phoneNumber: '手機號',
      wechatNumber: '微信號碼',
      email: '郵箱',
      company: '所屬企業',
      position: '職位',
      cardVisits: '名片訪問量',
      createTime: '創建時間',
      personalIntro: '個人簡介',
      imageDisplay: '圖片展示',
      companyLogo: '企業LOGO',
      companyName: '企業名稱',
      industry: '所屬行業',
      companyNotice: '企業公告',
      companyEmployees: '企業員工',
      customerCount: '客戶人數',
      notAuthorized: '未授權',
      people: '人',
      shortVideoTotalCount: '短視頻總次數',
      cardExpiryTime: '名片到期時間',
      productType: '商品類型',
      orderNumber: '訂單編號',
      orderTime: '下單時間',
      paymentMethod: '支付方式',
      addNotice: '新增公告',
      editNotice: '編輯公告',
      noticeTitle: '公告標題',
      noticeContent: '公告內容',
      publishTerminal: '發布終端',
      all: '全部',
      addEmployee: '新增員工',
      editEmployeeInfo: '編輯員工信息',
      back: '返回',
      basicInfo: '基礎信息',
      requiredFields: '都為必填項',
      loginAccount: '登錄賬號',
      loginPassword: '登錄密碼',
      passwordNotModified: '密碼不作修改則不填',
      employeeName: '員工姓名',
      employeeGender: '員工性別',
      male: '男',
      female: '女',
      employeePosition: '員工職務',
      pleaseSelect: '請選擇',
      permissionSetting: '權限設置',
      selectAll: '全選',
      permissionType: '權限類型',
      permissionName: '權限名稱',
      permissionDescription: '權限描述',
      clear: '清空',
      submit: '提交',
      activityContent: '活動內容',
      activityName: '活動名稱',
      price: '價格',
      operation: '操作',
      pleaseEnterActivityName: '請輸入活動名稱',
      pleaseEnterPrice: '請輸入價格',
      pleaseEnterDuration: '請輸入時長',
      year: '年',
      yuan: '港元',
      activityDate: '活動日期',
      phoneEdit: '電話編輯',
      consultationPhone: '諮詢電話',
      pleaseEnterConsultationPhone: '請輸入諮詢電話',
      save: '保存',
      publish: '發布',
      pleaseEnterUseTotalCount: '請輸入使用總人數',
      companyUseTotalCount: '企業使用總人數',
      person: '位',
      pleaseEnterCardDuration: '請輸入名片時長',
      companyUseCardDuration: '企業使用名片時長',
      pleaseEnterShortVideoCount: '請輸入短視頻數量',
      companyUseShortVideoCount: '企業使用短視頻數量',
      piece: '個',
      pleaseSelectDate: '請選擇日期',
      demoEnvironmentCannotSave: '演示環境不能保存,請諒解',
      durationRequired: '時長必填',
      priceRequired: '價格必填',
      maxAdd6Activities: '最多一次添加6個活動',
      operationSuccess: '操作成功',
      pleaseRelogin: '請重新登錄',
      activityTime: '活動時間',
      activityStatus: '活動狀態',
      publishTime: '發布時間',
      orderCount: '訂單數量',
      orderAmount: '訂單金額',
      today: '今天',
      last7Days: '近7天',
      last15Days: '近15天',
      last30Days: '近30天',
      companyNameOrAdminPhone: '企業名稱/管理員電話',
      query: '查詢',
      export: '導出',
      serialNumber: '序號',
      adminName: '管理員名稱',
      contactPhone: '聯繫電話',
      detail: '詳情',
      activityOrder: '活動訂單',
      cardDuration: '名片時長',
      cardUseCount: '名片使用人數',
      shortVideoCount: '短視頻數量',
      pendingOnline: '待上線',
      inProgress: '進行中',
      ended: '已結束',
      enterpriseDetail: '企業詳情',
      generalManager: '總經理',
      deputyGeneralManager: '副總經理',
      finance: '財務',
      operations: '運營',
      technicalDirector: '技術總監',
             hrSpecialist: '人事專員',
      // 新增的OEM管理相關文本
      cardEnd: '名片端',
      crm: 'crm',
      crmPcWebsiteApp: 'CRM-PC網站應用',
      cardPayment: '名片支付',
      wechatOfficialAccount: '微信公眾號',
      crmPayment: 'CRM支付',
      auditPassed: '審核通過',
      pendingReview: '待審核',
      rejected: '拒絕',
      success: '成功',
      failed: '失敗',
      singleEnterprise: '單企業',
      administratorPhone: '管理員手機號',
      companyPassword: '公司口令',
      appName: '小程序名稱',
      merchantId: '商戶ID',
      merchantKey: '商戶秘鑰',
      paymentP12Certificate: '支付p12證書',
      upload: '上傳',
      viewCardIdByPhone: '查看手機號對應的名片ID',
      phoneNumber: '手機號',
      cardId: '名片Id',
      userId: '用戶Id',
      companyId: '公司Id',
      close: '關閉',
      oemConfig: 'oem配置',
      systemName: '系統名稱',
      oemDomain: 'oem域名',
      companyLogo: '公司logo',
      websiteIcon: '網站icon',
      modifySuccess: '修改成功',
      saveSuccess: '保存成功',
      // 分頁組件文本
      total: '共 {total} 條',
      sizes: '條/頁',
      prev: '上一頁',
      next: '下一頁',
      jumper: '前往',
      page: '頁',
      advancedVersion: '高级版',
      normalVersion: '普通版',
      agent: '代理商',
      singleCompany: '單企業',
      notCertified: '未認證',
      certified: '已認證',
      certifying: '認證中',
      certificationFailed: '認證失敗',
      unknown: '未知',
      auditCertification: '認證審核',
      approve: '批准',
      reject: '拒絕',
      certificationRemark: '審核備註',
      pleaseEnterRemark: '請輸入審核備註',
      auditSuccess: '審核成功',
      auditFailed: '審核失敗',
      certificationApplyCompanyName: '申請認證企業名稱',
      certificationPhone: '申請人聯繫電話',
      certificationImages: '認證圖片',
     },
     // 按钮文本
    button: {
      login: '登錄',
      logout: '退出登錄',
      register: '註冊',
      forgotPassword: '忘記密碼',
      changePassword: '修改密碼',
      viewDetail: '查看詳情',
      download: '下載',
      upload: '上傳',
      export: '導出',
      import: '導入',
      refresh: '刷新',
      filter: '篩選',
      sort: '排序',
      exportAll: '全部導出',
      search: '查詢',
      confirm: '確定',
      cancel: '取消',
      add: '去補充',
      edit: '編輯',
      delete: '刪除'
    },
    // 状态文本
    status: {
      active: '啟用',
      inactive: '禁用',
      pending: '待處理',
      processing: '處理中',
      completed: '已完成',
      failed: '失敗',
      online: '在線',
      offline: '離線',
      all: '全部',
      normalCompany: '普通企業',
      authorizedCompany: '授權企業',
      expiredCompany: '授權已到期企業',
      applyingCompany: '申請認證企業',
      normalUser: '普通用戶',
      companyAdmin: '企業管理員'
    },
    // 消息提示
    message: {
      loginSuccess: '登錄成功',
      loginFailed: '登錄失敗',
      logoutSuccess: '退出成功',
      saveSuccess: '保存成功',
      deleteSuccess: '刪除成功',
      operationSuccess: '操作成功',
      operationFailed: '操作失敗',
      confirmDelete: '確認刪除嗎？',
      confirmLogout: '確認退出嗎？',
      confirmRelease: '審核通過立即發布?',
      confirmUpdateVersion: '是否立即更新版本?',
      noPermission: '沒有權限',
      networkError: '網絡錯誤',
      serverError: '服務器錯誤',
      pleaseEnterUsername: '請輸入賬號',
      pleaseEnterPassword: '請輸入密碼',
      pleaseEnterAgentId: '請輸入代理商ID',
      submitSuccess: '提交成功，即將刷新頁面',
      permissionManagement: '權限管理',
      startDate: '開始日期',
      endDate: '結束日期',
      companyNameOrPhone: '企業名稱/管理員電話',
      notSetAgentId: '還沒有設置代理商ID',
      enterNameOrPhone: '請輸入姓名或電話用戶',
      editNoticeSuccess: '編輯公告成功，刷新頁面',
      addNoticeSuccess: '新增公告成功，刷新頁面',
      editEmployeeSuccess: '編輯員工成功，刷新頁面',
      addEmployeeSuccess: '新增員工成功，刷新頁面',
      editEmployeeFailed: '編輯員工失敗',
      addEmployeeFailed: '新增員工失敗',
      systemNamePlaceholder: '如：睿哲智能CRM',
      oemDomainPlaceholder: '如：crm.yourdomain.com',
      logoSizePlaceholder: '尺寸：30*30',
      iconSizePlaceholder: '尺寸：128*128',
      pleaseEnterNoticeTitle: '請輸入公告標題',
      pleaseEnterNoticeContent: '請輸入公告內容',
      pleaseEnterJumpPath: '請輸入跳轉路徑',
      pleaseEnterLoginAccount: '請輸入登錄賬號',
      pleaseEnterEmployeeName: '請輸入員工姓名',
      uploadImageSizeLimit: '上傳頭像圖片大小不能超過 2MB!',
      uploadImageFormatError: '上傳頭像圖片只能是 JPG 格式!',
      viewCardIdByPhone: '查看手機號對應的名片ID',
      systemName: '系統名稱',
      oemDomain: 'oem域名',
      websiteIcon: '網站icon',
      merchantKey: '商戶秘鑰',
      paymentP12Certificate: '支付p12證書',
      languageSwitchedToChinese: '已切換到簡體中文',
      languageSwitchedToTraditional: '已切換到繁體中文',
      languageSwitchedToEnglish: 'Switched to English'
    }
  },
  'en': {
    // 通用
    common: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      search: 'Search',
      reset: 'Reset',
      submit: 'Submit',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      loading: 'Loading...',
      noData: 'No Data',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Info',
      rememberAccount: 'Remember Account',
      selectLanguage: 'Select Language',
      yes: 'Yes',
      no: 'No',
      tip: 'Tip'
    },
    // 导航菜单
    menu: {
      home: 'Home',
      dashboard: 'Dashboard',
      workbench: 'Workbench',
      userManage: 'User Management',
      systemSettings: 'System Settings',
      companyManage: 'Company Management',
      cardManage: 'Card Management',
      activityManage: 'Activity Management',
      orderManage: 'Order Management',
      dataAnalysis: 'Data Analysis',
      enterpriseService: 'Enterprise Service',
      companyManageList: 'Company Management List',
      oemManage: 'OEM Management',
      companyDetail: 'Company Detail',
      videoManage: 'Video Management',
      moduleManage: 'Module Management',
      permissionsManage: 'Permissions Management',
      operationRecords: 'Operation Records',
      serviceOrder: 'Service Order',
      visitorData: 'Visitor Data',
      cardDetail: 'Card Detail',
      companyCard: 'Company Card',
      companyNotice: 'Company Notice',
      yimaiSmartCard: 'Yimai Smart Card',
      yimaiCrmCard: 'Yimai CRM Card',
      wxappletManage: 'WeChat Applet Management',
      codeManage: 'Code Management',
      dataCenter: 'Data Center',
      updateAnnouncement: 'Update Announcement',
      publishActivity: 'Publish Activity',
      editActivity: 'Edit Activity',
      buyActivity: 'Buy Details',
      orderDetail: 'Order Detail',
      versionManage: 'Applet Version Management'
    },
    // 页面标题
    pageTitle: {
      home: 'Home',
      login: 'Login',
      dashboard: 'Dashboard',
      userList: 'User List',
      userDetail: 'User Detail',
      companyList: 'Company List',
      cardList: 'Card List',
      activityList: 'Activity List',
      orderList: 'Order List',
      companyManage: 'Company Management',
      customerManage: 'Customer Management',
      activityManage: 'Activity Management',
      serviceOrder: 'Service Order',
      permissionsManage: 'Permissions Management',
      cardPage: 'Card Detail',
      companyCardPage: 'Company Card',
      versionManage: 'Version Management',
      operationRecords: 'Operation Records',
      modelSwitch: 'Model Switch',
      visitorData: 'Visitor Data',
      companyVideo: 'Company Video',
      companyOemManage: 'Company OEM Management',
      companyNotice: 'Company Notice',
      yimaiSmartCard: 'Yimai Smart Card',
      wxappletManage: 'WeChat Applet Management',
      yimaiCrmCard: 'Yimai CRM Card',
      codeManage: 'Code Management',
      index: 'Home'
    },
    // 表单标签
    form: {
      username: 'Username',
      password: 'Password',
      email: 'Email',
      phone: 'Phone',
      name: 'Name',
      company: 'Company',
      role: 'Role',
      status: 'Status',
      createTime: 'Create Time',
      updateTime: 'Update Time',
      description: 'Description',
      remark: 'Remark',
      companyName: 'Company Name',
      administrator: 'Administrator',
      administratorPhone: 'Admin Phone',
      employeeCount: 'Employees',
      cardCount: 'Total Cards',
      unusedCardCount: 'Unused Cards',
      customerCount: 'Customers',
      wechatNumber: 'WeChat Number',
      expiryTime: 'Expiry Time',
      purchaseVersion: 'Purchase Version',
      companyType: 'Company Type',
      affiliatedCompany: 'Affiliated Company',
      certificationStatus: 'Certification Status',
      certificationTime: 'Certification Time',
      operation: 'Operation',
      detail: 'Detail',
      setting: 'Setting',
      cardId: 'ID',
      name: 'Name',
      phone: 'Phone',
      position: 'Position',
      cardVisits: 'Card Visits',
      createTime: 'Create Time',
      currentCompany: 'Current Company',
      totalPurchase: 'Total Purchase',
      paymentAmount: 'Payment Amount',
      deadline: 'Deadline',
      selectDate: 'Select Date',
      agentPrice: 'Agent Price',
      agentId: 'Agent ID',
      activityStatus: 'Activity Status',
      activityName: 'Activity Name',
      publishTime: 'Publish Time (First)',
      activityTime: 'Activity Time',
      activityId: 'Activity ID',
      useDuration: 'Use Duration',
      useCount: 'Use Count',
      shortVideo: 'Short Video',
      pleaseSelect: 'Please Select',
      newPublish: 'New Publish',
      ended: 'Ended',
      inProgress: 'In Progress',
      pending: 'Pending',
      unknown: 'Unknown',
      offline: 'Offline',
      serialNumber: 'Serial Number',
      durationPurchase: 'Duration Purchase/Year',
      countPurchase: 'Count Purchase/Person',
      videoPurchase: 'Video Purchase/Times',
      adminName: 'Admin Name',
      contactPhone: 'Contact Phone',
      companyNamePlaceholder: 'Company Name',
      adminNamePlaceholder: 'Admin Name',
      adminPhonePlaceholder: 'Admin Phone',
      searchKeyword: 'Search Keyword',
      create: 'Create',
      employeeName: 'Employee Name',
      gender: 'Gender',
      job: 'Job',
      loginAccount: 'Login Account',
      enabled: 'Enabled',
      disabled: 'Disabled',
      male: 'Male',
      female: 'Female',
      enabledStatus: 'Enabled',
      disabledStatus: 'Disabled',
      enable: 'Enable',
      disable: 'Disable',
      back: 'Back',
      openWechatScan: 'Open WeChat Scan',
      previewCardInfo: 'Preview User Card Info',
      delete: 'Delete',
      companyDetail: 'Company Detail',
      agentCompanyList: 'Agent Company List',
      setAgentPrice: 'Set Agent Price',
      setAsAgent: 'Set as Agent',
      yuanPerCard: 'HKD/Card',
      inputAgentPrice: 'Input Agent Price',
      cancelAgentQualification: 'Cancel Agent Qualification?',
      versionName: 'Version Name',
      versionDescription: 'Version Description',
      versionPrice: 'Version Price',
      versionFeatures: 'Version Features',
      versionStatus: 'Version Status',
      versionType: 'Version Type',
      versionCode: 'Version Code',
      versionNumber: 'Version Number',
      releaseDate: 'Release Date',
      updateDate: 'Update Date',
      versionNotes: 'Version Notes',
      versionHistory: 'Version History',
      versionComparison: 'Version Comparison',
      upgradeVersion: 'Upgrade Version',
      downgradeVersion: 'Downgrade Version',
      versionManagement: 'Version Management',
      versionControl: 'Version Control',
      versionBackup: 'Version Backup',
      versionRestore: 'Version Restore',
      userEnd: 'User End',
      crmEnd: 'CRM End',
      templateId: 'Template ID',
      description: 'Description',
      createTime: 'Create Time',
      operation: 'Operation',
      codeCommit: 'Code Commit',
      submitSuccess: 'Submit Success',
      usernameOrCompanyName: 'Username/Company Name',
      loginUsername: 'Login Username',
      companyName: 'Company Name',
      operationName: 'Operation Name',
      operationContent: 'Operation Content',
      operationTime: 'Operation Time',
      purchaseService: 'Purchase Service',
      setAgent: 'Set Agent',
      serialNumber: 'Serial Number',
      appName: 'App Name',
      crmEnterpriseServiceSwitch: 'CRM Enterprise Service Switch',
      valueAddedServiceSwitch: 'Value Added Service Switch',
      userAuthorizationSwitch: 'User Authorization Switch',
      phoneAuthorizationSwitch: 'Phone Authorization Switch',
      open: 'Open',
      close: 'Close',
      pleaseEnterVideoLimit: 'Please enter video limit number',
      lengthLimit: 'Length should be 1 to 8 characters',
      selectTime: 'Select Time',
      startDate: 'Start Date',
      endDate: 'End Date',
      phoneNumber: 'Phone Number',
      pleaseEnterPhoneNumber: 'Please enter phone number',
      pleaseSelect: 'Please Select',
      submitTime: 'Submit Time',
      notContacted: 'Not Contacted',
      contacted: 'Contacted',
      confirmContact: 'Confirm Contact',
      contactedStatus: 'Contacted',
      operator: 'Operator',
      lastWeek: 'Last Week',
      lastMonth: 'Last Month',
      lastThreeMonths: 'Last Three Months',
      shortVideoSwitch: 'Short Video Switch',
      uploadableVideoCount: 'Uploadable Video Count',
      contactPhone: 'Contact Phone',
      edit: 'Edit',
      videoLimitCount: 'Video Limit Count',
      cancel: 'Cancel',
      companyId: 'Company ID',
      configId: 'Config ID',
      bossUserId: 'BOSS User ID',
      bossCardId: 'BOSS Card ID',
      companyPassword: 'Company Password',
      configEnd: 'Config End',
      cardEnd: 'Card End',
      crmPcWebsiteApp: 'CRM-PC Website App',
      cardPayment: 'Card Payment',
      wechatOfficialAccount: 'WeChat Official Account',
      crmPayment: 'CRM Payment',
      appId: 'AppID',
      appSecret: 'AppSecret',
      companyKey: 'companyKey',
      merchantNumber: 'Merchant Number',
      auditStatus: 'Audit Status',
      submitFailed: 'Submit Failed',
      submitSuccess: 'Submit Success',
      auditInProgress: 'Audit In Progress',
      auditSubmitFailed: 'Audit Submit Failed',
      auditFailed: 'Audit Failed',
      auditPassed: 'Audit Passed',
      releaseSuccess: 'Release Success',
      releaseFailed: 'Release Failed',
      pendingReview: 'Pending Review',
      rejected: 'Rejected',
      authorizationStatus: 'Authorization Status',
      success: 'Success',
      failed: 'Failed',
      enterpriseType: 'Enterprise Type',
      singleEnterprise: 'Single Enterprise',
      modify: 'Modify',
      view: 'View',
      oemConfig: 'OEM Config',
      currentEnterprise: 'Current Enterprise',
      boosUserId: 'BOOS User ID',
      boosCardId: 'BOOS Card ID',
      administratorPhone: 'Administrator Phone',
      companyPasswordLabel: 'Company Password',
      configEndLabel: 'Config End',
      appNameLabel: 'App Name',
      appIdLabel: 'AppID',
      appSecretLabel: 'AppSecret',
      companyKeyLabel: 'companyKey',
      merchantNumberLabel: 'Merchant Number',
      auditStatusLabel: 'Audit Status',
      authorizationStatusLabel: 'Authorization Status',
      enterpriseTypeLabel: 'Enterprise Type',
      createTimeLabel: 'Create Time',
      operationLabel: 'Operation',
      modifyOemCompanyInfo: 'Modify OEM Company Info',
      selectDateRange: 'Select Date Range',
      dataOverview: 'Data Overview',
      userPortrait: 'User Portrait',
      newUserCount: 'New User Count',
      userCount: 'User Count',
      totalUserCount: 'Total User Count',
      userGrowth: 'User Growth',
      userCountGrowth: 'User Count Growth',
      genderAgeDistribution: 'Gender & Age Distribution',
      last7Days: 'Last 7 Days',
      last15Days: 'Last 15 Days',
      last30Days: 'Last 30 Days',
      today: 'Today',
      yesterday: 'Yesterday',
      last7DaysRange: 'Last 7 Days',
      companyName: 'Company Name',
      query: 'Query',
      manager: 'Manager',
      contactInfo: 'Contact Info',
      appName: 'App Name',
      appletCategory: 'Applet Category',
      userEnd: 'User End',
      crmEnd: 'CRM End',
      latestStatus: 'Latest Status',
      currentVersion: 'Current Version',
      selectVersion: 'Select Version',
      getVersion: 'Get Version',
      operation: 'Operation',
      getExperienceCode: 'Get Experience Code',
      getAuditResult: 'Get Audit Result',
      submitAudit: 'Submit Audit',
      release: 'Release',
      versionSelection: 'Version Selection',
      version: 'Version',
      description: 'Description',
      versionUpdate: 'Version Update',
      cancel: 'Cancel',
      confirm: 'Confirm',
      scanCodeExperience: 'Scan Code Experience',
      failureReason: 'Failure Reason',
      none: 'None',
      draftBox: 'Draft Box',
      versionNumber: 'Version Number',
      description: 'Description',
      sourceApplet: 'Source Applet',
      sourceAppletId: 'Source Applet ID',
      uploadDeveloper: 'Upload Developer',
      submitTime: 'Submit Time',
      addToTemplateLibrary: 'Add to Template Library',
      appletTemplateLibrary: 'Applet Template Library',
      templateId: 'Template ID',
      addToTemplateLibraryTime: 'Add to Template Library Time',
      addVersion: 'Add Version',
      addAppletVersionInfo: 'Add Applet Version Info',
      appletId: 'Applet ID',
      versionNum: 'Version Number',
      desc: 'Description',
      refresh: 'Refresh',
      export: 'Export',
      newSituation: 'New Situation',
      todayNewUsers: 'Today New Users',
      todayNewCompany: 'Today New Company',
      totalCompanyCount: 'Total Company Count',
      pageNotFound: '404 Page Not Found',
      serialNumber: 'Serial Number',
      noticeTitle: 'Notice Title',
      noticeContent: 'Notice Content',
      publishTerminal: 'Publish Terminal',
      appletEnd: 'Applet End',
      all: 'All',
      startTime: 'Start Time',
      endTime: 'End Time',
      jumpType: 'Jump Type',
      absolutePath: 'Absolute Path',
      appletPath: 'Applet Path',
      jumpPath: 'Jump Path',
      // 组件相关文本
      userInfo: 'User Information',
      companyInfo: 'Company Information',
      administratorInfo: 'Administrator Information',
      orderDetail: 'Order Detail',
      orderList: 'Order List',
      userAvatar: 'User Avatar',
      name: 'Name',
      phoneNumber: 'Phone Number',
      wechatNumber: 'WeChat Number',
      email: 'Email',
      company: 'Company',
      position: 'Position',
  
      createTime: 'Create Time',
      personalIntro: 'Personal Introduction',
      imageDisplay: 'Image Display',
      companyLogo: 'Company Logo',
      companyName: 'Company Name',
      industry: 'Industry',
      companyNotice: 'Company Notice',
      companyEmployees: 'Company Employees',
      customerCount: 'Customer Count',
      notAuthorized: 'Not Authorized',
      people: 'People',
      shortVideoTotalCount: 'Short Video Total Count',
      cardExpiryTime: 'Card Expiry Time',
      productType: 'Product Type',
      orderNumber: 'Order Number',
      orderTime: 'Order Time',
      paymentMethod: 'Payment Method',
      addNotice: 'Add Notice',
      editNotice: 'Edit Notice',
      noticeTitle: 'Notice Title',
      noticeContent: 'Notice Content',
      publishTerminal: 'Publish Terminal',
      all: 'All',
      addEmployee: 'Add Employee',
      editEmployeeInfo: 'Edit Employee Info',
      back: 'Back',
      basicInfo: 'Basic Information',
      requiredFields: 'All Required Fields',
      loginAccount: 'Login Account',
      loginPassword: 'Login Password',
      passwordNotModified: 'Password not modified if not filled',
      employeeName: 'Employee Name',
      employeeGender: 'Employee Gender',
      male: 'Male',
      female: 'Female',
      employeePosition: 'Employee Position',
      pleaseSelect: 'Please Select',
      permissionSetting: 'Permission Setting',
      selectAll: 'Select All',
      permissionType: 'Permission Type',
      permissionName: 'Permission Name',
      permissionDescription: 'Permission Description',
      clear: 'Clear',
      submit: 'Submit',
      activityContent: 'Activity Content',
      activityName: 'Activity Name',
      price: 'Price',
      operation: 'Operation',
      pleaseEnterActivityName: 'Please enter activity name',
      pleaseEnterPrice: 'Please enter price',
      pleaseEnterDuration: 'Please enter duration',
      year: 'Year',
      yuan: 'HKD',
      activityDate: 'Activity Date',
      phoneEdit: 'Phone Edit',
      consultationPhone: 'Consultation Phone',
      pleaseEnterConsultationPhone: 'Please enter consultation phone',
      save: 'Save',
      publish: 'Publish',
      pleaseEnterUseTotalCount: 'Please enter use total count',
      companyUseTotalCount: 'Company Use Total Count',
      person: 'Person',
      pleaseEnterCardDuration: 'Please enter card duration',
      companyUseCardDuration: 'Company Use Card Duration',
      pleaseEnterShortVideoCount: 'Please enter short video count',
      companyUseShortVideoCount: 'Company Use Short Video Count',
      piece: 'Piece',
      pleaseSelectDate: 'Please select date',
      demoEnvironmentCannotSave: 'Demo environment cannot save, please understand',
      durationRequired: 'Duration required',
      priceRequired: 'Price required',
      maxAdd6Activities: 'Maximum 6 activities can be added at once',
      operationSuccess: 'Operation successful',
      pleaseRelogin: 'Please relogin',
      activityTime: 'Activity Time',
      activityStatus: 'Activity Status',
      publishTime: 'Publish Time',
      orderCount: 'Order Count',
      orderAmount: 'Order Amount',
      today: 'Today',
      last7Days: 'Last 7 Days',
      last15Days: 'Last 15 Days',
      last30Days: 'Last 30 Days',
      companyNameOrAdminPhone: 'Company Name/Admin Phone',
      query: 'Query',
      export: 'Export',
      serialNumber: 'Serial Number',
      adminName: 'Admin Name',
      contactPhone: 'Contact Phone',
      detail: 'Detail',
      activityOrder: 'Activity Order',
      cardDuration: 'Card Duration',
      cardUseCount: 'Card Use Count',
      shortVideoCount: 'Short Video Count',
      pendingOnline: 'Pending Online',
      inProgress: 'In Progress',
      ended: 'Ended',
      enterpriseDetail: 'Enterprise Detail',
      generalManager: 'General Manager',
      deputyGeneralManager: 'Deputy General Manager',
      finance: 'Finance',
      operations: 'Operations',
      technicalDirector: 'Technical Director',
      hrSpecialist: 'HR Specialist',
      // New OEM management related text
      cardEnd: 'Card End',
      crm: 'CRM',
      crmPcWebsiteApp: 'CRM-PC Website App',
      cardPayment: 'Card Payment',
      wechatOfficialAccount: 'WeChat Official Account',
      crmPayment: 'CRM Payment',
      auditPassed: 'Audit Passed',
      pendingReview: 'Pending Review',
      rejected: 'Rejected',
      success: 'Success',
      failed: 'Failed',
      agent: 'Agent',
      singleEnterprise: 'Single Enterprise',
      administratorPhone: 'Administrator Phone',
      companyPassword: 'Company Password',
      appName: 'App Name',
      merchantId: 'Merchant ID',
      merchantKey: 'Merchant Key',
      paymentP12Certificate: 'Payment P12 Certificate',
      upload: 'Upload',
      viewCardIdByPhone: 'View Card ID by Phone',
      phoneNumber: 'Phone Number',
      cardId: 'Card ID',
      userId: 'User ID',
      companyId: 'Company ID',
      close: 'Close',
      oemConfig: 'OEM Config',
      systemName: 'System Name',
      oemDomain: 'OEM Domain',
      companyLogo: 'Company Logo',
      websiteIcon: 'Website Icon',
      modifySuccess: 'Modified Successfully',
      saveSuccess: 'Saved Successfully',
      // Pagination component text
      total: 'Total {total} items',
      sizes: 'items/page',
      prev: 'Previous',
      next: 'Next',
      jumper: 'Go to',
      page: 'page',
      advancedVersion: 'Advanced',
      normalVersion: 'Normal',
      agent: 'Agent',
      singleCompany: 'Single Company',
      notCertified: 'Not Certified',
      certified: 'Certified',
      certifying: 'Certifying',
      certificationFailed: 'Certification Failed',
      unknown: 'Unknown',
      auditCertification: 'Certification Audit',
      approve: 'Approve',
      reject: 'Reject',
      certificationRemark: 'Audit Remark',
      pleaseEnterRemark: 'Please enter audit remark',
      auditSuccess: 'Audit Success',
      auditFailed: 'Audit Failed',
      certificationApplyCompanyName: 'Certification Apply Company Name',
      certificationPhone: 'Applicant Contact Phone',
      certificationImages: 'Certification Images',
     },
     // 按钮文本
    button: {
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      forgotPassword: 'Forgot Password',
      changePassword: 'Change Password',
      viewDetail: 'View Detail',
      download: 'Download',
      upload: 'Upload',
      export: 'Export',
      import: 'Import',
      refresh: 'Refresh',
      filter: 'Filter',
      sort: 'Sort',
      exportAll: 'Export All',
      search: 'Search',
      confirm: 'Confirm',
      cancel: 'Cancel',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete'
    },
    // 状态文本
    status: {
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
      online: 'Online',
      offline: 'Offline',
      all: 'All',
      normalCompany: 'Normal Company',
      authorizedCompany: 'Authorized Company',
      expiredCompany: 'Expired Company',
      applyingCompany: 'Applying Company',
      singleCompany: 'Single Company',
      normalUser: 'Normal User',
      companyAdmin: 'Company Admin'
    },
    // 消息提示
    message: {
      loginSuccess: 'Login Success',
      loginFailed: 'Login Failed',
      logoutSuccess: 'Logout Success',
      saveSuccess: 'Save Success',
      deleteSuccess: 'Delete Success',
      operationSuccess: 'Operation Success',
      operationFailed: 'Operation Failed',
      confirmDelete: 'Confirm Delete?',
      confirmLogout: 'Confirm Logout?',
      confirmRelease: 'Release after approval?',
      confirmUpdateVersion: 'Update version immediately?',
      noPermission: 'No Permission',
      networkError: 'Network Error',
      serverError: 'Server Error',
      pleaseEnterUsername: 'Please enter username',
      pleaseEnterPassword: 'Please enter password',
      pleaseEnterAgentId: 'Please enter agent ID',
      submitSuccess: 'Submit success, page will refresh soon',
      permissionManagement: 'Permission Management',
      startDate: 'Start Date',
      endDate: 'End Date',
      companyNameOrPhone: 'Company Name/Admin Phone',
      notSetAgentId: 'Agent ID not set yet',
      enterNameOrPhone: 'Please enter name or phone user',
      editNoticeSuccess: 'Edit notice success, refresh page',
      addNoticeSuccess: 'Add notice success, refresh page',
      editEmployeeSuccess: 'Edit employee success, refresh page',
      addEmployeeSuccess: 'Add employee success, refresh page',
      editEmployeeFailed: 'Edit employee failed',
      addEmployeeFailed: 'Add employee failed',
      confirmDeleteNotice: 'Confirm delete notice?',
      systemNamePlaceholder: 'e.g.: Ruizhe Smart CRM',
      oemDomainPlaceholder: 'e.g.: crm.yourdomain.com',
      logoSizePlaceholder: 'Size: 30*30',
      iconSizePlaceholder: 'Size: 128*128',
      pleaseEnterNoticeTitle: 'Please enter notice title',
      pleaseEnterNoticeContent: 'Please enter notice content',
      pleaseEnterJumpPath: 'Please enter jump path',
      pleaseEnterLoginAccount: 'Please enter login account',
      pleaseEnterEmployeeName: 'Please enter employee name',
      uploadImageSizeLimit: 'Upload avatar image size cannot exceed 2MB!',
      uploadImageFormatError: 'Upload avatar image can only be JPG format!',
      viewCardIdByPhone: 'View Card ID by Phone Number',
      systemName: 'System Name',
      oemDomain: 'OEM Domain',
      websiteIcon: 'Website Icon',
      merchantKey: 'Merchant Key',
      paymentP12Certificate: 'Payment P12 Certificate',
      languageSwitchedToChinese: 'Switched to Simplified Chinese',
      languageSwitchedToTraditional: 'Switched to Traditional Chinese',
      languageSwitchedToEnglish: 'Switched to English'
    }
  }
};

// 获取指定语言的文本
export function getText(language, category, key) {
  const langConfig = i18nConfig[language] || i18nConfig['zh-TW'];
  const categoryConfig = langConfig[category];
  return categoryConfig ? categoryConfig[key] : key;
}

// 获取当前语言的文本
export function getCurrentText(category, key) {
  const currentLanguage = localStorage.getItem('language') || 'zh-TW';
  return getText(currentLanguage, category, key);
}

// 语言切换工具类
export class I18nManager {
  constructor() {
    this.currentLanguage = localStorage.getItem('language') || 'zh-TW';
    this.listeners = [];
  }

  // 获取当前语言
  getCurrentLanguage() {
    return this.currentLanguage;
  }

  // 切换语言
  setLanguage(language) {
    if (this.currentLanguage !== language) {
      this.currentLanguage = language;
      localStorage.setItem('language', language);
      this.notifyListeners();
    }
  }

  // 获取文本
  getText(category, key) {
    return getText(this.currentLanguage, category, key);
  }

  // 添加监听器
  addListener(listener) {
    this.listeners.push(listener);
  }

  // 移除监听器
  removeListener(listener) {
    const index = this.listeners.indexOf(listener);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }

  // 通知所有监听器
  notifyListeners() {
    this.listeners.forEach(listener => {
      if (typeof listener === 'function') {
        listener(this.currentLanguage);
      }
    });
  }
}

// 创建全局实例
export const i18nManager = new I18nManager();



// WEBPACK FOOTER //
// ./src/utils/i18n.js